






















import CommonBase from "../CommonBase";
import {Component, Prop} from "vue-property-decorator";

@Component
export default class LocationOccurringCostInfoDialog extends CommonBase {
    @Prop({default: false})
    value!: boolean;

    get show() {
        return this.value;
    }
    set show(v: boolean) {
        this.$emit("input", v);
    }

    confirm() {
      this.show = false;
      this.$emit("confirm");
    }
}
